export const servicesKeys = {
  connect: () => ['CONNECT'] as const,
  disconnect: () => ['DISCONNECT'] as const,
  info: () => ['INFO'] as const,
  subscriptions: () => ['SUBSCRIPTIONS'] as const,
};
